// PatternPickerDialog — ISP-9999 (gordon-0913-gallery-theme-wallpaper-pattern-
// image-parity). Gordon's UX note (2026-09-13 10:00 PT): the Pattern tab's full
// library is "a robust section on the Edit Wheel page" that would displace the
// rest of the Gallery Theme panel if shown inline, so it opens in a popup
// instead — this dialog IS that popup. It wraps BackgroundPatternPanel
// UNCHANGED (import, not copy): the same 45-pattern grid + "Pattern size" scale
// slider + line-art/background colour pickers the Edit-Wheel builder's live
// "SVG Patterns" tab renders (see galleryTheme.js's PATTERN TAB SOURCE OF TRUTH
// note for why this — not the dead legacy 28-pattern <Pattern/> mask component
// — is the correct reuse target). `fullScreen` below is the standard MUI
// responsive-dialog idiom, matching the "390px width -> full-screen sheet"
// behaviour the note asks to mirror from the builder's own pickers.
import React from "react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import BackgroundPatternPanel from "../backgroundPatterns/BackgroundPatternPanel";
import { T } from "./constants";

export default function PatternPickerDialog({
  open,
  onClose,
  value,
  onApply,
  segmentColor,
}) {
  const muiTheme = useTheme();
  const fullScreen = useMediaQuery(muiTheme.breakpoints.down("sm"));

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullScreen={fullScreen}
      fullWidth
      maxWidth="sm"
      aria-labelledby="pattern-picker-title"
      PaperProps={{
        "data-testid": "pattern-picker-paper",
        ...(fullScreen
          ? { sx: { display: "flex", flexDirection: "column" } }
          : {}),
      }}
    >
      <DialogTitle
        id="pattern-picker-title"
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          fontFamily: T.fontBody,
        }}
      >
        Browse all patterns
        <IconButton aria-label="Close pattern picker" onClick={onClose} size="small">
          <CloseRoundedIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent
        dividers
        data-testid="pattern-picker-content"
        sx={
          fullScreen
            ? { display: "flex", flexDirection: "column", flex: 1, minHeight: 0 }
            : undefined
        }
      >
        <BackgroundPatternPanel
          value={value}
          onApply={onApply}
          segmentColor={segmentColor}
          fillHeight={fullScreen}
        />
      </DialogContent>
    </Dialog>
  );
}
